import React, { FC } from 'react'
import ApproveRequestInfoCooperationContainer from 'containers/ApproveRequestInfoCooperation'

const ApproveRequestInfoCooperationPage: FC = () => {
  return <ApproveRequestInfoCooperationContainer />
}

export default ApproveRequestInfoCooperationPage
